<!--
  ~ Copyright (C) 2017 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<div class="minimised__tile" [@slideIn] [ngClass]="theme">
  <span class="minimised-tile__title">{{ title }}</span>
  <h3 class="subject">{{ subject }}</h3>
</div>
